import { worldViewerWindow } from './const';
import { CHELAudio } from './CHELAudio';
import { getAudioList, getMixerMuteAt, getMixerSettingAt, pushNullToAudioList, setAudioList } from './logics/dataOps';
const defineNextAudioIndexFromAudioList = ()=>{
    const audioList = getAudioList();
    for(let index = 0; index < audioList.length; index++){
        if (audioList[index] == null || audioList[index] === undefined) {
            return index;
        }
    }
    pushNullToAudioList();
    return audioList.length - 1;
};
/**
 * @remarks
 * オーディオ
 * C++側, heliodor.jsからも呼出される
 *
 * @param fileName
 * @param type
 * @param play
 * @param loop
 * @param volume
 */ worldViewerWindow.createAudio = (fileName, type, play, loop, volume)=>{
    const index = defineNextAudioIndexFromAudioList();
    const helAudio = new CHELAudio(type, volume);
    setAudioList(helAudio, index);
    helAudio.load(fileName, play, loop);
    return index;
};
/**
 * @remarks
 * C++側, heliodor.jsからも呼出される
 *
 * @param index
 */ worldViewerWindow.releaseAudioIndex = (index)=>{
    var ref;
    const audioList = getAudioList();
    if (audioList[index] === null) {
        return;
    }
    (ref = audioList[index]) === null || ref === void 0 ? void 0 : ref.release();
    setAudioList(null, index);
};
/**
 * @remarks
 * C++側, heliodor.jsからも呼出される
 *
 * @param index
 * @param loop
 */ worldViewerWindow.playAudio = (index, loop)=>{
    var ref;
    const audioList = getAudioList();
    if (audioList[index] === null) {
        return;
    }
    (ref = audioList[index]) === null || ref === void 0 ? void 0 : ref.play(loop);
};
/**
 * @remarks
 * C++側, heliodor.jsからも呼出される
 *
 * @param index
 */ worldViewerWindow.stopAudio = (index)=>{
    var ref;
    const audioList = getAudioList();
    if (audioList[index] == null) {
        return;
    }
    (ref = audioList[index]) === null || ref === void 0 ? void 0 : ref.stop();
};
/**
 * @remarks
 * C++側, heliodor.jsからも呼出される
 *
 * @param index
 */ worldViewerWindow.isPlayAudio = (index)=>{
    var ref;
    const audioList = getAudioList();
    if (audioList[index] == null) {
        return 0;
    }
    return ((ref = audioList[index]) === null || ref === void 0 ? void 0 : ref.isPlay()) || 0;
};
/**
 * @remarks
 * C++側, heliodor.jsからも呼出される
 *
 * @param index
 * @param realVolume
 */ worldViewerWindow.setAudioVolume = (index, realVolume)=>{
    var ref;
    const audioList = getAudioList();
    if (audioList[index] == null) {
        return;
    }
    return (ref = audioList[index]) === null || ref === void 0 ? void 0 : ref.setVolume(realVolume);
};
/**
 * @remarks
 * C++側, heliodor.jsからも呼出される
 *
 * @param type
 */ worldViewerWindow.hel_mixer_GetVolume = (type)=>{
    return parseFloat(getMixerSettingAt(type));
};
/**
 * @remarks
 * C++側, heliodor.jsからも呼出される
 *
 * @param type
 */ worldViewerWindow.hel_mixer_IsMute = (type)=>{
    return parseFloat(getMixerMuteAt(type));
};
